import { useTranslation } from 'next-i18next';
import React from 'react';
import { UiComponentElementInterface, UserProfileComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';
import ProfileForm from '../profile/ProfileForm';

const UserProfileComponent = ({ uiComponent }: UiComponentElementInterface<UserProfileComponentInterface>) => {
  const user = useSelector(({ common }) => common.user);
  const { t } = useTranslation();
  return (
    <div
      className={`w-full`}
      style={{
        color: uiComponent?.styling?.textColor || '#000',
      }}>
      <TitleAndDescription component={uiComponent!} />
      {user ? (
        <ProfileForm
          hideTitle
          hideAvatar={uiComponent?.showAvatar === false}
          background={uiComponent?.customStyling?.formBackground}
          opacity={uiComponent?.customStyling?.formOpacity}
          textColor={uiComponent?.styling.textColor}
        />
      ) : (
        <EmptyComponent componentName={t('pagebuilder:userprofile')} />
      )}
    </div>
  );
};

export default UserProfileComponent;
